import Vue from 'vue';
import type { PersonalPlaylistCard } from './personal-playlists';

const key = 'simple-music.sidebar-playlists.v1';
let hidden: string[] = [];
try {
  const saved = JSON.parse(localStorage.getItem(key) || '[]');
  if (Array.isArray(saved)) hidden = saved.filter((id): id is string => typeof id === 'string');
} catch { /* A damaged preference must not hide the library. */ }
export const sidebarPlaylists = Vue.observable({ hidden, error: '' });
export function setSidebarPlaylistVisible(ids: string[], visible: boolean) {
  const next = new Set(sidebarPlaylists.hidden);
  for (const id of ids) visible ? next.delete(id) : next.add(id);
  try { localStorage.setItem(key, JSON.stringify([...next])); }
  catch { sidebarPlaylists.error = '显示偏好未能保存，请重试。'; return; }
  sidebarPlaylists.hidden = [...next];
  sidebarPlaylists.error = '';
}
export function sidebarPlaylistIdentity(card: PersonalPlaylistCard) {
  const match = /^account:(qq|netease):([^:]+):(.+)$/.exec(card.id);
  return match ? { platform: match[1], accountId: match[2], playlistId: match[3] } : { platform: 'local', accountId: '', playlistId: card.id };
}
